import loopCreate from './loopCreate.js';
import loopFix from './loopFix.js';
import loopDestroy from './loopDestroy.js';
export default {
  loopCreate,
  loopFix,
  loopDestroy
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/core/loop/index.js
// module id = 1161
// module chunks = 9